// Store Locator with Mapbox integration
document.addEventListener("DOMContentLoaded", () => {
  // Initialize the store locator
  initBoutique();
});

// Global variables
function initBoutique() {
  // Find all store detail panel sections
  const storeSections = document.querySelectorAll(
    ".store-detail-panel__section"
  );

  // Loop through each section
  storeSections.forEach((section) => {
    const header = section.querySelector(".store-detail-panel__section-header");
    const content = section.querySelector(
      ".store-detail-panel__section-content"
    );
    const toggle = section.querySelector(".store-detail-panel__toggle");

    // Check if this section has both header and content (making it an accordion)
    if (header && content) {
      if (!section.classList.contains("open")) {
        // Initially ensure content is closed (you might have CSS for this already)
        section.classList.add("closed");
      }

      // Add click event listener to the header
      header.addEventListener("click", () => {
        // Toggle the open class on content
        section.classList.toggle("open");
        section.classList.toggle("closed");

        toggle.setAttribute(
          "aria-expanded",
          section.classList.contains("open")
        );

        // Optionally toggle a class on the header too to show it's active
        header.classList.toggle("active");
      });
    }
  });
}
